module.exports = __webpack_public_path__ + "static/media/rain 10d.d10b6c70.png";